/**
 * Created by Alex Xia on 07/27/2020.
 * Description:
 * Add Auto Tag for Admin Console
 * ------ maintenance history ------
 * 08/11/2021 Marcus Zhao add UI and function for pulling coordinates.
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AdminPageSetting } from '../../admin-page-setting.model';
import { ActivatedRoute } from '@angular/router';
import { adminPageRoutingMap } from '../../admin-page-setting.constants';
import { Store, select } from '@ngrx/store';
import { Subscription } from 'rxjs';
import * as _lodash from 'lodash';
import { lastCustomActionSelector } from '../../../../redux/reducers/action-history.reducer';
import { ToastService } from '../../../../widgets/toast/toast.service';
import { AppState } from '../../../../redux';
import { getSystemConfigState } from '../../../../redux/reducers/system-config-view.reducer';
import { StoreQuerierService } from '../../../../services/store-querier.service';
import { MapTile } from '../../../../tamalelibs/models/map-tile.model';
import { ChangeMapTileStatusAction, CHANGE_MAP_TILE_STATUS_SUCCESS, PullingCoordinatesAction } from '../../../../tamalelibs/redux/map-tile.actions';
import { NotificationStyles } from '../../../../widgets/notification/notification.model';
import { businessConstants } from '../../../../tamalelibs/constants/business.constants';
import { pullingCoordinatesSelector } from '../../../../tamalelibs/redux/map-tile.reducer';

@Component({
    selector: 'tam-admin-google-map-service',
    templateUrl: './admin-google-map-service.component.html',
    styleUrls: ['./admin-google-map-service.component.scss']
})
export class AdminGoogleMapServiceComponent implements OnInit, OnDestroy {
    currPage: AdminPageSetting;
    currPageUrl: string;

    maptile: MapTile = new MapTile();
    toastMsg: string;
    isProgressing = false;

    private _subscribed = false;
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _route: ActivatedRoute,
        private _store: Store<AppState>,
        private _toast: ToastService,
        private _storeQuerier: StoreQuerierService,
    ) {
    }

    ngOnInit() {
        this._handlePageRouting(this._route.snapshot.data['page']);
        this._initMapTileStatus();
        this._initSubscriptions();
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
        this._subscribed = false;
    }

    /*
    *  only enable or disable autotag status, not affect other fields
    */
    changeMapTileEnableStatus(value) {
        this.maptile.enable = value;
        const action = new ChangeMapTileStatusAction();
        action.payload = this.maptile;
        this._store.dispatch(action);
    }
    /**
     * send patch maptile api
     *
     * @memberof AdminGoogleMapServiceComponent
     */
    clickStartPulling() {
        this.isProgressing = true;
        this._store.dispatch(new PullingCoordinatesAction());
    }

    private _initMapTileStatus() {
        const systemConfig = this._storeQuerier.queryBySelector(getSystemConfigState);
        if (systemConfig && systemConfig.maptile) {
            this.maptile.enable = systemConfig.maptile['enable'];
        }
    }

    private _handlePageRouting(currPageUrl: string) {
        this.currPageUrl = currPageUrl;
        this.currPage = adminPageRoutingMap.get(this.currPageUrl);
    }

    private _initSubscriptions() {
        if (!this._subscribed) {
            this._subscribed = true;
            this._destroySubscriptions.push(
                this._store.pipe(
                    select(lastCustomActionSelector)
                ).subscribe(action => {
                    this._onSubscribeActionMessage(action);
                }),
                this._store.pipe(
                    select(pullingCoordinatesSelector),
                ).subscribe(res => {
                    this._onPullingCoordinatesAction(res);
                }),
            );
        }
    }

    private _onSubscribeActionMessage(action) {
        if (action.type === CHANGE_MAP_TILE_STATUS_SUCCESS) {
            if (this.maptile.enable) {
                this.toastMsg = businessConstants.maptile.mapTileEnabledMsg;
            } else {
                // disable map tile
                this.toastMsg = businessConstants.maptile.mapTileDisabledMsg;
            }

            this._toast.notify({
                message: this.toastMsg,
                style: NotificationStyles.Success
            });
        }
    }

    private _onPullingCoordinatesAction(res) {
        if (res === 1) {
            this.isProgressing = false;
        }
    }
}
